var _rect, _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 25C40.5 30.7885 35.7885 35.5 30 35.5C24.2115 35.5 19.5 30.7885 19.5 25C19.5 19.2115 24.2115 14.5 30 14.5C35.7885 14.5 40.5 19.2115 40.5 25Z",
    fill: "url(#paint0_linear_23663_24462)",
    stroke: "url(#paint1_radial_23663_24462)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2368 24.75C14.2368 25.432 14.2896 26.0985 14.3819 26.75H8.42632C7.92034 26.75 7.43194 26.543 7.06945 26.1695C6.70647 25.7955 6.5 25.2852 6.5 24.75V23.5C6.5 22.9648 6.70647 22.4545 7.06945 22.0805C7.43194 21.707 7.92034 21.5 8.42632 21.5H14.6105C14.365 22.5639 14.2394 23.654 14.2368 24.7488V24.75ZM22.4432 11.75H8.42632C7.92034 11.75 7.43194 11.543 7.06945 11.1695C6.70647 10.7955 6.5 10.2852 6.5 9.75V8.5C6.5 7.96482 6.70647 7.45446 7.06945 7.08046C7.43194 6.70697 7.92034 6.5 8.42632 6.5H24.4736C24.9796 6.5 25.468 6.70697 25.8305 7.08046C26.1935 7.45446 26.3999 7.96482 26.3999 8.5V9.74906C26.3994 10.0605 26.3283 10.3657 26.1945 10.6409C24.8991 10.8246 23.6359 11.1981 22.4432 11.75ZM15.3236 19.25H8.42632C7.92034 19.25 7.43194 19.043 7.06945 18.6695C6.70647 18.2955 6.5 17.7852 6.5 17.25V16C6.5 15.4648 6.70647 14.9545 7.06945 14.5805C7.43194 14.207 7.92034 14 8.42632 14H19.0168C17.4149 15.4337 16.1499 17.2288 15.3236 19.25ZM7.06945 29.5805C7.43194 29.207 7.92034 29 8.42632 29H14.8785C15.4728 30.946 16.4654 32.7358 17.7865 34.25H8.42632C7.92034 34.25 7.43194 34.043 7.06945 33.6695C6.70647 33.2955 6.5 32.7852 6.5 32.25V31C6.5 30.4648 6.70647 29.9545 7.06945 29.5805Z",
    fill: "url(#paint2_linear_23663_24462)",
    stroke: "url(#paint3_radial_23663_24462)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_23663_24462)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint4_linear_23663_24462)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint5_radial_23663_24462)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_23663_24462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 39.5C29 38.9477 29.4477 38.5 30 38.5H33.6341C34.1864 38.5 34.6341 38.9477 34.6341 39.5V46C34.6341 46.5523 34.1864 47 33.6341 47H30C29.4477 47 29 46.5523 29 46V39.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6829 31C36.6829 30.4477 37.1306 30 37.6829 30H41.3171C41.8694 30 42.3171 30.4477 42.3171 31V46C42.3171 46.5523 41.8694 47 41.3171 47H37.6829C37.1306 47 36.6829 46.5523 36.6829 46V31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3659 36C44.3659 35.4477 44.8136 35 45.3659 35H49C49.5523 35 50 35.4477 50 36V46C50 46.5523 49.5523 47 49 47H45.3659C44.8136 47 44.3659 46.5523 44.3659 46V36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_23663_24462",
    x: 16,
    y: 15,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23663_24462"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23663_24462",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_23663_24462",
    x: 29,
    y: 30,
    width: 22,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23663_24462"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23663_24462",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23663_24462",
    x1: 17.9474,
    y1: 14,
    x2: 26.2922,
    y2: 40.0193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_23663_24462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.31171 2.96321) rotate(43.0655) scale(32.9729 35.2568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23663_24462",
    x1: 5,
    y1: 6,
    x2: 18.8487,
    y2: 37.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_23663_24462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.15385 -8.42308) rotate(52.125) scale(37.275 38.7187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23663_24462",
    x1: 24,
    y1: 23,
    x2: 40,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_23663_24462",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 23) scale(32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.01758c3d0258354f2c40fef908eec852.svg";
export { ForwardRef as ReactComponent };